export enum Cutbar {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER'
}
